import { FC } from "react";

import { Box, Flex, Heading, Text, Image } from "@chakra-ui/react";
import { Skills } from "pages/about/skills/Skills";

import { configs, Content, MarkdownFile, useContent } from "shared/content/Content";
import { Experience } from "pages/about/experience/Experience";
import { AboutPageId } from "utils/useScroll";
import { PageHeader } from "shared/page-header/PageHeader";
import { Link as ChakraLink } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

export const About: FC = () => {
    const content = useContent(MarkdownFile.About);

   

    return (
        
            <Box id={AboutPageId}>
                    <PageHeader label="About Me" />
        <Box maxW="100vw" overflowX="hidden" px={{ base: 4, md: 8 }}>
            <Flex pt="8" gap={{ base: 6, md: 6, lg: 12 }} direction={{ base: "column", md: "row" }}>
                <Box flex="0.35" data-aos="fade-up">
                    <picture>
                        <source type="image/webp" srcSet={configs.common.mainPicture}></source>
                        <source type="image/jpeg" srcSet={configs.common.mainPictureJPG}></source>
                        <Image borderRadius="xl" src={configs.common.mainPicture} w="100%" alt="profile image" />
                    </picture>
                </Box>
                <Box flex="0.85">
                    <Heading data-aos="fade-down">
                        {configs.common.name}
                    </Heading>
                    <Flex alignItems="center">
                        <Text fontWeight="bold" opacity="0.5" data-aos="fade" data-aos-delay="200">
                            {configs.common.pronunciation}
                        </Text>

                    </Flex>
                    <Box pt="4" data-aos="fade-up" data-aos-delay="400">
                        <Content fontSize="lg">{content.about}</Content>
                    </Box>
                </Box>
            </Flex>
            <Flex
                direction={{ base: "column", md: "row" }}
                gap={{ base: 16, md: 6, lg: 12 }}
                mt="16"
                justifyContent="space-between"
            >
                
                <Box flex="0.6" overflow="hidden">
                    <Experience />
                    <Skills />
                </Box>
            </Flex>
            
            <Flex
                direction={{ base: "column", md: "row" }}
                gap={{ base: 16, md: 6, lg: 12 }}
                mt="16"
                justifyContent="space-between"
            >
                
                
            </Flex>
        </Box>
        </Box>
    );
};
